import React from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ProgressChart = ({ 
  title, 
  data, 
  type = 'line',
  dataKeys = [],
  height = 300,
  colors = ['var(--color-accent)', 'var(--color-primary)']
}) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center gap-2 text-xs">
              <div 
                className="w-3 h-3 rounded-full" 
                style={{ backgroundColor: entry?.color }}
              />
              <span className="text-muted-foreground">{entry?.name}:</span>
              <span className="font-semibold data-text text-foreground">{entry?.value}</span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const ChartComponent = type === 'line' ? LineChart : BarChart;
  const DataComponent = type === 'line' ? Line : Bar;

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-md">
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4">
        {title}
      </h3>
      <div className="w-full" style={{ height: `${height}px` }}>
        <ResponsiveContainer width="100%" height="100%">
          <ChartComponent data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="name" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            {dataKeys?.map((key, index) => (
              <DataComponent
                key={key?.dataKey}
                type={type === 'line' ? 'monotone' : undefined}
                dataKey={key?.dataKey}
                name={key?.name}
                stroke={colors?.[index % colors?.length]}
                fill={colors?.[index % colors?.length]}
                strokeWidth={type === 'line' ? 3 : undefined}
                dot={type === 'line' ? { r: 4 } : undefined}
                activeDot={type === 'line' ? { r: 6 } : undefined}
              />
            ))}
          </ChartComponent>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ProgressChart;